import { set, symmetricDifference } from '@imcc/utilities';

export function toggleExpandedReducer(state, action) {
  const { term } = action;
  const tab = state.tabs[state.indexName];
  const tabCurrentlyExpanded = tab.expanded || [];
  const newExpanded = symmetricDifference(tabCurrentlyExpanded, [term]);

  return set(state, ['tabs', state.indexName, 'expanded'], newExpanded);
}
